{
    "COMMON": {
        "NotAssigned": "Non assegnato",
        "Assigned": "Assegnato",
        "Contacted": "Contattato",
        "NoAnswer": "Non risponde",
        "OpportunityCreated": "@tenant:i18n.ACTIVITY_LOGS.CreateOpportunityCommand",
        "ContactCreated": "@tenant:contact.messages.contatto.creato.sentenceCase",
        "NotInterested": "Non interessato",
        "Callback": "Da richiamare",
        "WrongNumber": "Numero errato",
        "NotFinanciable": "Non finanziabile",
        "Management": "In gestione"
    },
    "CONTACTS": {
        "Contact": "@tenant:contact.singular",
        "LabelWithName": "@tenant:i18n.CONTACTS.LabelWithName",
        "Validations": {
            "PhoneNumberAlreadyUsedByOtherContact": "@tenant:i18n.CONTACTS.Validations.PhoneNumberAlreadyUsedByOtherContact",
            "CONTACT_FIRSTNAME_TOO_SHORT": "Il nome deve essere di almeno 3 caratteri",
            "CONTACT_LASTNAME_TOO_SHORT": "Il cognome deve essere di almeno 3 caratteri",
            "CONTACT_PHONE_TOO_SHORT": "Il numero di telefono deve essere di almeno 10 caratteri",
            "CONTACT_BIRTHDATE_INVALID": "La data di nascita non è valida",
            "CONTACT_PHONE_ALREADY_EXISTS": "@tenant:i18n.CONTACTS.Validations.CONTACT_PHONE_ALREADY_EXISTS",
            "CONTACT_NOTE_EMPTY": "La nota non può essere vuota",
            "SCHEDULE_OPPORTUNITY_NOT_FOUND": "@tenant:i18n.CONTACTS.Validations.SCHEDULE_OPPORTUNITY_NOT_FOUND"
        },
        "AssigneeWithParam": "@tenant:i18n.ACTIVITY_LOGS.AssigneeWithParam",
        "NotAssigned": "@tenant:i18n.CONTACTS.NotAssigned"
    },
    "OPPORTUNITIES": {
        "Opportunity": "@tenant:opportunity.singular",
        "StateWithParam": "@tenant:i18n.OPPORTUNITIES.StateWithParam",
        "LabelWithName": "@tenant:i18n.OPPORTUNITIES.LabelWithName",
        "AssigneeWithParam": "@tenant:i18n.OPPORTUNITIES.AssigneeWithParam",
        "NotAssigned": "@tenant:i18n.OPPORTUNITIES.NotAssigned",
        "Practice": "Pratica",
        "Approved": "Approvato",
        "Liquidated": "Liquidato",
        "Rejected": "Rifiutato",
        "Deliberated": "Deliberata",
        "QuoteProposed": "Proposto preventivo",
        "InProgress": "In lavorazione",
        "Completed": "Completata",
        "Cancelled": "Annullata"
    },
    "ACTIVITY_LOGS": {
        "v2": {
            "filters": {
                "relatedType": "Tipo elemento",
                "operation": "Operazione",
                "dateRange": "Periodo",
                "dateRangePlaceholder": "dd/mm/aaaa - dd/mm/aaaa"
            }
        },
        "changeTypes": {
            "ADDED": "AGGIUNTO",
            "UNCHANGED": "INVARIATO",
            "DELETED": "ELIMINATO",
            "UPDATED": "MODIFICATO"
        },
        "fields": {
            "contact": {
                "null": "Campo vuoto",
                "reCallDate": "Richiamare il",
                "phone": "Telefono",
                "address": "Indirizzo",
                "atcId": "Ragione Sociale ATC",
                "birthDate": "Data di Nascita",
                "city": "Comune",
                "province": "Provincia",
                "postalCode": "CAP",
                "region": "Regione",
                "taxCode": "Codice Fiscale",
                "email": "Email",
                "operatorId": "Operatore",
                "categoryId": "Categoria",
                "channelId": "Canale",
                "stateId": "Stato",
                "branchId": "Filiale",
                "firstName": "Nome",
                "lastName": "Cognome"
            },
            "opportunity": {
                "null": "Campo vuoto",
                "invalidJson": "Formato dati non valido",
                "statusId": "Stato",
                "operatorId": "Operatore",
                "branchId": "Filiale",
                "economicDetail": "Dettagli Economici",
                "callDate": "Data Chiamata",
                "reCallDate": "Richiamare il",
                "title": "Titolo",
                "description": "Descrizione",
                "notes": "Note",
                "contactId": "@tenant:contact.singular",
                "categoryId": "Categoria",
                "channelId": "Canale",
                "contactName": "@tenant:contact.labels.nome.contatto",
                "companyName": "Nome Azienda",
                "startDate": "Data Inizio",
                "endDate": "Data Fine",
                "createdDate": "Data Creazione"
            },
            "campaign": {
                "null": "Campo vuoto",
                "name": "Nome",
                "state": "Stato",
                "startDate": "Data Inizio",
                "endDate": "Data Fine"
            },
            "campaignContact": {
                "null": "Campo vuoto",
                "contactId": "@tenant:contact.singular",
                "campaignId": "Campagna",
                "state": "Stato",
                "branchId": "Filiale",
                "operatorId": "Operatore",
                "recallDate": "Richiamare il"
            },
            "economicDetail": {
                "amountId": "Importo",
                "durationId": "Durata",
                "netRevenueId": "Ricavo Netto",
                "paymentId": "Pagamento",
                "percentageId": "Percentuale",
                "commissionId": "Commissione",
                "instituteId": "Istituto",
                "startDateId": "Data Inizio",
                "endDateId": "Data Fine",
                "renewalId": "Rinnovo",
                "tan": "TAN",
                "taeg": "TAEG"
            },
            "estimate": {
                "description": "Descrizione"
            }
        },
        "ContactCreated": "@tenant:contact.messages.contatto.creato.sentenceCase",
        "ContactDeleted": "@tenant:i18n.ACTIVITY_LOGS.ContactDeleted",
        "ContactUpdated": "@tenant:contact.messages.contatto.aggiornato.sentenceCase",
        "ContactCategoryCreated": "@tenant:i18n.ACTIVITY_LOGS.ContactCategoryCreated",
        "ContactCategoryDeleted": "@tenant:i18n.ACTIVITY_LOGS.ContactCategoryDeleted",
        "ContactCategoryUpdated": "@tenant:i18n.ACTIVITY_LOGS.ContactCategoryUpdated",
        "ContactChannelCreated": "@tenant:i18n.ACTIVITY_LOGS.ContactChannelCreated",
        "ContactChannelDeleted": "@tenant:i18n.ACTIVITY_LOGS.ContactChannelDeleted",
        "ContactChannelUpdated": "@tenant:i18n.ACTIVITY_LOGS.ContactChannelUpdated",
        "ContactDocumentCreated": "@tenant:i18n.ACTIVITY_LOGS.ContactDocumentCreated",
        "ContactDocumentDeleted": "@tenant:i18n.ACTIVITY_LOGS.ContactDocumentDeleted",
        "ContactDocumentUpdated": "@tenant:i18n.ACTIVITY_LOGS.ContactDocumentUpdated",
        "ContactNoteCreated": "@tenant:i18n.ACTIVITY_LOGS.ContactNoteCreated",
        "ContactNoteDeleted": "@tenant:i18n.ACTIVITY_LOGS.ContactNoteDeleted",
        "ContactNoteUpdated": "@tenant:i18n.ACTIVITY_LOGS.ContactNoteUpdated",
        "OpportunityCreated": "@tenant:i18n.ACTIVITY_LOGS.CreateOpportunityCommand",
        "OpportunityDeleted": "@tenant:i18n.ACTIVITY_LOGS.OpportunityDeleted",
        "OpportunityUpdated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityUpdated",
        "OpportunityDocumentCreated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityDocumentCreated",
        "OpportunityDocumentDeleted": "@tenant:i18n.ACTIVITY_LOGS.OpportunityDocumentDeleted",
        "OpportunityDocumentUpdated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityDocumentUpdated",
        "OpportunityFinancialDetail": "@tenant:i18n.ACTIVITY_LOGS.OpportunityFinancialDetail",
        "OpportunityFinancialDetailCreated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityFinancialDetailCreated",
        "OpportunityFinancialDetailDeleted": "@tenant:i18n.ACTIVITY_LOGS.OpportunityFinancialDetailDeleted",
        "OpportunityFinancialDetailUpdated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityFinancialDetailUpdated",
        "OpportunityNoteCreated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityNoteCreated",
        "OpportunityNoteDeleted": "@tenant:i18n.ACTIVITY_LOGS.OpportunityNoteDeleted",
        "OpportunityNoteUpdated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityNoteUpdated",
        "OpportunityStatus": "@tenant:i18n.ACTIVITY_LOGS.OpportunityStatus",
        "OpportunityStatusCreated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityStatusCreated",
        "OpportunityStatusDeleted": "@tenant:i18n.ACTIVITY_LOGS.OpportunityStatusDeleted",
        "OpportunityStatusUpdated": "@tenant:i18n.ACTIVITY_LOGS.OpportunityStatusUpdated",
        "PipelineCreated": "Pipeline creata",
        "PipelineDeleted": "Pipeline eliminata",
        "PipelineUpdated": "Pipeline aggiornata",
        "ProductCreated": "Prodotto creato",
        "ProductDeleted": "Prodotto eliminato",
        "ProductUpdated": "Prodotto aggiornato",
        "ProductStateFlowCreated": "Flusso di stato prodotto creato",
        "ProductStateFlowDeleted": "Flusso di stato prodotto eliminato",
        "ProductStateFlowUpdated": "Flusso di stato prodotto aggiornato",
        "ScheduleCreated": "Pianificazione creata",
        "ScheduleDeleted": "Pianificazione eliminata",
        "ScheduleUpdated": "Pianificazione aggiornata",
        "AssigneeWithParam": "@tenant:i18n.ACTIVITY_LOGS.AssigneeWithParam",
        "CreateOpportunityCommand": "@tenant:i18n.ACTIVITY_LOGS.CreateOpportunityCommand",
        "UpdateOpportunityCommand": "@tenant:i18n.ACTIVITY_LOGS.OpportunityUpdated",
        "UpdateOpportunityEconomicDetailOnlyCommand": "@tenant:i18n.ACTIVITY_LOGS.UpdateOpportunityEconomicDetailOnlyCommand",
        "CreateEstimateCommand": "Preventivo creato",
        "CreateContactCommand": "@tenant:contact.messages.contatto.creato.sentenceCase",
        "UpdateContactCommand": "@tenant:contact.messages.contatto.aggiornato.sentenceCase",
        "CreateCampaignCommand": "Campagna creata",
        "UpdateCampaignCommand": "Campagna aggiornata",
        "LEAD_ALREADY_EXIST": "@tenant:i18n.ACTIVITY_LOGS.LEAD_ALREADY_EXIST",
        "LEAD_UPDATE": "@tenant:i18n.ACTIVITY_LOGS.LEAD_UPDATE",
        "LEAD_INSERT": "@tenant:i18n.ACTIVITY_LOGS.LEAD_INSERT"
    },
    "ECONOMIC_DETAIL_TEMPLATES": {
        "Payment": "Montante Lordo",
        "Amount": "Importo Rata",
        "Net Revenue": "Netto Ricavo",
        "Duration": "Durata",
        "Percentage": "Percentuale",
        "Commissions": "Commissioni",
        "startDate": "Data di inizio",
        "Institute": "Istituto",
        "EndDate": "Data di fine",
        "RenewalDate": "Data di rinnovo",
        "Rate": "Tasso",
        "tan": "TAN",
        "taeg": "TAEG"
    },
    "NOTIFICATIONS": {
        "ERRORS": {
            "All quotas exceeded": "Tutte le quote sono state superate",
            "exceeded quotas": "Quote superate",
            "Quota exceeded": "Quota superata",
            "Monthly quota exceeded": "Quota mensile superata",
            "Daily quota exceeded": "Quota giornaliera superata",
            "Hourly quota exceeded": "Quota oraria superata",
            "Invalid recipient": "Destinatario non valido",
            "Invalid email format": "Formato email non valido",
            "Recipient not found": "Destinatario non trovato",
            "Provider not configured": "Provider non configurato",
            "Provider error": "Errore del provider",
            "Sending failed": "Invio fallito",
            "Rate limit exceeded": "Limite di frequenza superato"
        }
    },
    "CONSTRAINT_OPERATORS": {
        "LessThan": "Minore di",
        "LessThanOrEqual": "Minore o uguale a",
        "GreaterThan": "Maggiore di",
        "GreaterThanOrEqual": "Maggiore o uguale a",
        "Equal": "Uguale a",
        "NotEqual": "Diverso da",
        "Before": "Prima di",
        "After": "Dopo di",
        "BeforeOrEqual": "Prima o uguale a",
        "AfterOrEqual": "Dopo o uguale a",
        "Between": "Compreso tra",
        "NotBetween": "Non compreso tra",
        "Lt": "Minore di",
        "Lte": "Minore o uguale a",
        "Gt": "Maggiore di",
        "Gte": "Maggiore o uguale a",
        "Eq": "Uguale a",
        "Neq": "Diverso da",
        "Ne": "Diverso da",
        "In": "Contenuto in",
        "NotIn": "Non contenuto in",
        "Contains": "Contiene",
        "StartsWith": "Inizia con",
        "EndsWith": "Finisce con",
        "IsNull": "È vuoto",
        "IsNotNull": "Non è vuoto",
        "MinLength": "Lunghezza minima",
        "MaxLength": "Lunghezza massima",
        "RequiredIf": "Obbligatorio se",
        "RequiredIfNot": "Obbligatorio se non",
        "RequiredUnless": "Obbligatorio a meno che"
    },
    "PRIME_NG": {
        "startsWith": "Inizia con",
        "contains": "Contiene",
        "notContains": "Non contiene",
        "endsWith": "Finisce con",
        "equals": "Uguale",
        "notEquals": "Non uguale",
        "noFilter": "Nessun filtro",
        "lt": "Minore di",
        "lte": "Minore o uguale a",
        "gt": "Maggiore di",
        "gte": "Maggiore o uguale a",
        "dateIs": "Data è",
        "dateIsNot": "Data non è",
        "dateBefore": "Data è prima",
        "dateAfter": "Data è dopo",
        "clear": "Cancella",
        "apply": "Applica",
        "matchAll": "Corrispondi tutto",
        "matchAny": "Corrispondi qualsiasi",
        "addRule": "Aggiungi regola",
        "removeRule": "Rimuovi regola",
        "accept": "Sì",
        "reject": "No",
        "choose": "Scegli",
        "upload": "Carica",
        "cancel": "Annulla",
        "completed": "Completato",
        "pending": "In attesa",
        "fileSizeTypes": [
            "B",
            "KB",
            "MB",
            "GB",
            "TB",
            "PB",
            "EB",
            "ZB",
            "YB"
        ],
        "dayNames": [
            "Domenica",
            "Lunedì",
            "Martedì",
            "Mercoledì",
            "Giovedì",
            "Venerdì",
            "Sabato"
        ],
        "dayNamesShort": [
            "Dom",
            "Lun",
            "Mar",
            "Mer",
            "Gio",
            "Ven",
            "Sab"
        ],
        "dayNamesMin": [
            "Do",
            "Lu",
            "Ma",
            "Me",
            "Gi",
            "Ve",
            "Sa"
        ],
        "monthNames": [
            "Gennaio",
            "Febbraio",
            "Marzo",
            "Aprile",
            "Maggio",
            "Giugno",
            "Luglio",
            "Agosto",
            "Settembre",
            "Ottobre",
            "Novembre",
            "Dicembre"
        ],
        "monthNamesShort": [
            "Gen",
            "Feb",
            "Mar",
            "Apr",
            "Mag",
            "Giu",
            "Lug",
            "Ago",
            "Set",
            "Ott",
            "Nov",
            "Dic"
        ],
        "chooseYear": "Scegli anno",
        "chooseMonth": "Scegli mese",
        "chooseDate": "Scegli data",
        "prevDecade": "Decennio precedente",
        "nextDecade": "Prossimo decennio",
        "prevYear": "Anno precedente",
        "nextYear": "Prossimo anno",
        "prevMonth": "Mese precedente",
        "nextMonth": "Prossimo mese",
        "prevHour": "Ora precedente",
        "nextHour": "Prossima ora",
        "prevMinute": "Minuto precedente",
        "nextMinute": "Prossimo minuto",
        "prevSecond": "Secondo precedente",
        "nextSecond": "Prossimo secondo",
        "am": "am",
        "pm": "pm",
        "today": "Oggi",
        "weekHeader": "Sm",
        "firstDayOfWeek": 1,
        "dateFormat": "dd/mm/yy",
        "weak": "Debole",
        "medium": "Medio",
        "strong": "Forte",
        "passwordPrompt": "Inserisci una password",
        "emptyFilterMessage": "Nessun risultato trovato",
        "searchMessage": "{0} risultati disponibili",
        "selectionMessage": "{0} elementi selezionati",
        "emptySelectionMessage": "Nessun elemento selezionato",
        "emptySearchMessage": "Nessun risultato trovato",
        "emptyMessage": "Nessuna opzione disponibile",
        "aria": {
            "trueLabel": "Vero",
            "falseLabel": "Falso",
            "nullLabel": "Non selezionato",
            "star": "1 stella",
            "stars": "{star} stelle",
            "selectAll": "Tutti gli elementi selezionati",
            "unselectAll": "Tutti gli elementi deselezionati",
            "close": "Chiudi",
            "previous": "Precedente",
            "next": "Successivo",
            "navigation": "Navigazione",
            "scrollTop": "Scorri in alto",
            "moveTop": "Sposta in alto",
            "moveUp": "Sposta su",
            "moveDown": "Sposta giù",
            "moveBottom": "Sposta in basso",
            "moveToTarget": "Sposta verso destinazione",
            "moveToSource": "Sposta verso origine",
            "moveAllToTarget": "Sposta tutto verso destinazione",
            "moveAllToSource": "Sposta tutto verso origine",
            "pageLabel": "{page}",
            "firstPageLabel": "Prima pagina",
            "lastPageLabel": "Ultima pagina",
            "nextPageLabel": "Pagina successiva",
            "prevPageLabel": "Pagina precedente",
            "rowsPerPageLabel": "Righe per pagina",
            "jumpToPageDropdownLabel": "Menu a tendina vai alla pagina",
            "jumpToPageInputLabel": "Input vai alla pagina",
            "selectRow": "Riga selezionata",
            "unselectRow": "Riga deselezionata",
            "expandRow": "Riga espansa",
            "collapseRow": "Riga compressa",
            "showFilterMenu": "Mostra menu filtro",
            "hideFilterMenu": "Nascondi menu filtro",
            "filterOperator": "Operatore filtro",
            "filterConstraint": "Vincolo filtro",
            "editRow": "Modifica riga",
            "saveEdit": "Salva modifica",
            "cancelEdit": "Annulla modifica",
            "listView": "Vista elenco",
            "gridView": "Vista griglia",
            "slide": "Diapositiva",
            "slideNumber": "{slideNumber}",
            "zoomImage": "Ingrandisci immagine",
            "zoomIn": "Ingrandisci",
            "zoomOut": "Rimpicciolisci",
            "rotateRight": "Ruota a destra",
            "rotateLeft": "Ruota a sinistra"
        }
    },
    "INVITATIONS": {
        "Titles": {
            "SendFailed": "Errore invio invito",
            "ResendFailed": "Errore reinvio invito",
            "CompletionFailed": "Accesso non completato",
            "Expired": "Invito scaduto",
            "Invalid": "Invito non valido",
            "Foreign": "Organizzazione non corretta"
        },
        "Errors": {
            "EmailAlreadyExists": "Esiste già un account con questo indirizzo email. Usa un altro indirizzo o gestisci l’account esistente.",
            "EmailAlreadyInvited": "Questo indirizzo email ha già un invito attivo per un’altra società.",
            "OrganizationNotFound": "La società non esiste o non è attiva.",
            "OrganizationUnavailable": "Non è stato possibile verificare la società. Riprova tra poco.",
            "OrganizationSettingsInactive": "Le impostazioni della società sono disattivate o archiviate. Chiedi a un amministratore di verificarle prima di inviare l’invito.",
            "OrganizationInitializationFailed": "Non è stato possibile predisporre le impostazioni della società. Contatta l’assistenza.",
            "ForeignGroup": "Uno dei gruppi selezionati non appartiene a questa società.",
            "InvalidRole": "Uno dei ruoli selezionati non è consentito per questa società.",
            "SendFailed": "Non è stato possibile inviare l’email di invito. È stato programmato un nuovo tentativo.",
            "NotFound": "Non è disponibile un invito valido per questo account.",
            "NotResendable": "Questo invito non può essere reinviato nello stato attuale.",
            "InvalidExistingIdentity": "Non è stato possibile identificare univocamente l’account associato all’invito. Contatta l’assistenza.",
            "ProvisioningFailed": "Non è stato possibile completare l’attivazione dell’account. Riprova o contatta l’assistenza.",
            "InvalidSubject": "Accedi con l’account associato all’invito per completare l’attivazione.",
            "Expired": "Questo invito è scaduto. Chiedi a un amministratore di inviarne uno nuovo.",
            "InvalidMembership": "L’account risulta associato a un’organizzazione diversa. Contatta l’assistenza.",
            "InvalidMembershipType": "L’account non risulta registrato tramite un invito valido della società. Contatta l’assistenza.",
            "FirstNameRequired": "Inserisci il nome della persona da invitare.",
            "LastNameRequired": "Inserisci il cognome della persona da invitare.",
            "EmailRequired": "Inserisci l’indirizzo email della persona da invitare.",
            "EmailInvalid": "Inserisci un indirizzo email valido.",
            "GroupRequired": "Seleziona almeno un gruppo per la persona da invitare.",
            "InvalidGroup": "Uno dei gruppi selezionati non è valido.",
            "InvalidRequest": "I dati dell’invito non sono validi. Controllali e riprova.",
            "SessionRefreshFailed": "Il tuo account è stato attivato, ma non è stato possibile aggiornare l’accesso. Riprova o accedi nuovamente.",
            "NetworkError": "Connessione al server non disponibile. Verifica la connessione e riprova.",
            "Unauthorized": "La sessione è scaduta o non è valida. Accedi nuovamente.",
            "Forbidden": "Non hai i permessi necessari per questa operazione.",
            "Unexpected": "Operazione non completata. Riprova o contatta l’assistenza.",
            "UnknownError": "Operazione non completata. Riprova o contatta l’assistenza."
        }
    }
}
